import { SendPriceMatchCompetitorInformation } from "@preferredMedical/Models/ProductDetails/PriceMatch/SendPriceMatchCompetitorInformation";
import { SendPriceMatchContactInformation } from "@preferredMedical/Models/ProductDetails/PriceMatch/SendPriceMatchContactInformation";
import { SendPriceMatchProductInformation } from "@preferredMedical/Models/ProductDetails/PriceMatch/SendPriceMatchProductInformation";

export class SendPriceMatchRequest {
    customer: SendPriceMatchContactInformation;
    competitor: SendPriceMatchCompetitorInformation;
    product: SendPriceMatchProductInformation;
    comments = "";
    emailTos: string[] = [];

    constructor() {
        this.customer = new SendPriceMatchContactInformation();
        this.competitor = new SendPriceMatchCompetitorInformation();
        this.product = new SendPriceMatchProductInformation();
    }
}
